(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pcs-set-bouwer"] && !Shopify.designMode) return;
  try {
    
class PcsSetBouwer extends HTMLElement {
  connectedCallback() {
    this.tiers = JSON.parse(this.dataset.tiers || '[]');
    this.i18n = JSON.parse(this.dataset.i18n || '{}');
    this.bundle = [];
    this.shipText = this.dataset.shipping || '';
    this.initTabs();
    this.initHeat();
    this.initCards();
    this.initModal();
    this.initBundleButtons();
    this.initCarousel();
    this.render();
  }

  money(c){ return '€' + (c/100).toFixed(2).replace('.', ','); }
  discountFor(n){ let d=0; this.tiers.forEach(t=>{ if(n>=t.n) d=t.d; }); return d; }

  initTabs(){
    this.querySelectorAll('[data-tab]').forEach(btn=>{
      btn.addEventListener('click', ()=>{
        const id=btn.dataset.tab;
        this.querySelectorAll('[data-panel]').forEach(p=>{ p.hidden=true; p.classList.remove('is-active'); });
        this.querySelectorAll('[data-tab]').forEach(t=>{ t.classList.remove('is-active'); t.setAttribute('aria-selected','false'); });
        const panel=this.querySelector('[data-panel="'+id+'"]');
        if(panel){ panel.hidden=false; panel.classList.add('is-active'); }
        btn.classList.add('is-active'); btn.setAttribute('aria-selected','true');
      });
    });
  }

  initHeat(){
    const btns=this.querySelectorAll('[data-heat]');
    btns.forEach(b=>b.addEventListener('click', ()=>{
      btns.forEach(x=>x.classList.remove('is-active'));
      b.classList.add('is-active');
      this.heat=b.dataset.heat;
      this.applyHeat();
    }));
  }
  applyHeat(){
    this.querySelectorAll('[data-card]').forEach(card=>{
      const ind=card.dataset.inductie!=='false';
      const neutral=card.dataset.heatNeutral==='true';
      const show=(this.heat==='inductie' && !neutral)?ind:true;
      card.style.display=show?'':'none';
    });
  }

  pdata(card){ try{ return JSON.parse(card.querySelector('[data-pdata]').textContent); }catch(e){ return null; } }

  initCards(){
    this.querySelectorAll('[data-card]').forEach(card=>{
      card.querySelectorAll('[data-open-modal]').forEach(el=> el.addEventListener('click', ()=> this.openModal(card)));
      const single=card.querySelector('[data-add-single]');
      if(single) single.addEventListener('click', ()=>{
        const d=this.pdata(card);
        this.addToBundle({ vid:Number(single.dataset.vid), pid:d.id, title:d.title, variantTitle:'', price:d.variants[0].price, image:d.image });
        single.textContent=this.i18n.added||'✓ Toegevoegd'; single.style.background='#1f7a34';
        setTimeout(()=>{ single.textContent=this.i18n.addLabel||'Voeg toe'; single.style.background=''; },1500);
      });
    });
  }

  /* ---- Modal ---- */
  initModal(){
    this.modal=this.querySelector('[data-modal]');
    this.querySelector('[data-modal-close]').addEventListener('click', ()=> this.closeModal());
    this.modal.addEventListener('click', e=>{ if(e.target===this.modal) this.closeModal(); });
  }
  closeModal(){ this.modal.classList.remove('is-open'); document.body.style.overflow=''; }
  openModal(card){
    const d=this.pdata(card); if(!d) return;
    this.modalData=d; this.selVariant=d.variants[0];
    this.querySelector('[data-modal-img]').src=d.image||'';
    const uspArr=(d.usps||'').split('\n').map(s=>s.replace(/<br\s*\/?>/gi,'').trim()).filter(Boolean);
    const uspHtml=uspArr.length?('<ul class="pcs-sb__modal-usps">'+uspArr.map(u=>'<li>'+u+'</li>').join('')+'</ul>'):'';
    const sizes=d.variants.length>1?('<div class="pcs-sb__modal-sizes"><div class="pcs-sb__modal-sizes-label">'+(this.i18n.chooseSize||'Kies je maat:')+'</div><div class="pcs-sb__size-opts">'+d.variants.map((v,i)=>'<button type="button" class="pcs-sb__size-btn'+(i===0?' is-active':'')+'" data-size="'+i+'"'+(v.available?'':' disabled')+'>'+v.title+'</button>').join('')+'</div></div>'):'';
    const acc=this.buildAccordions(d);
    this.querySelector('[data-modal-info]').innerHTML=
      '<div class="pcs-sb__modal-brand">'+(d.brand||'')+'</div>'+
      '<h3 class="pcs-sb__modal-title">'+d.title+'</h3>'+
      (d.desc?'<p class="pcs-sb__modal-desc">'+d.desc+'</p>':'')+
      '<div class="pcs-sb__modal-price" data-modal-price>'+this.money(this.selVariant.price)+'</div>'+
      uspHtml+sizes+
      '<button type="button" class="pcs-sb__modal-add" data-modal-add>'+(this.i18n.addToSet||'Voeg toe aan set')+'</button>'+
      acc;
    this.wireModal();
    this.modal.classList.add('is-open'); document.body.style.overflow='hidden';
  }
  buildAccordions(d){
    let html='<div class="pcs-sb__acc">';
    if(d.kenmerken){ html+=this.accItem(this.i18n.features||'Kenmerken', d.kenmerken.replace(/\n/g,'<br>')); }
    if(d.specs&&d.specs.length){ html+=this.accItem(this.i18n.specs||'Details & specificaties', d.specs.map(s=>'<div class="pcs-sb__spec-row"><span>'+s.label+'</span><span>'+s.value+'</span></div>').join('')); }
    if(this.shipText){ html+=this.accItem(this.i18n.shipping||'Verzending & garantie', this.shipText.replace(/\n/g,'<br>')); }
    return html+'</div>';
  }
  accItem(title, body){
    return '<div class="pcs-sb__acc-item"><button type="button" class="pcs-sb__acc-head">'+title+'<span class="pcs-sb__acc-plus">+</span></button><div class="pcs-sb__acc-body">'+body+'</div></div>';
  }
  wireModal(){
    const info=this.querySelector('[data-modal-info]');
    info.querySelectorAll('[data-size]').forEach(b=> b.addEventListener('click', ()=>{
      info.querySelectorAll('[data-size]').forEach(x=>x.classList.remove('is-active'));
      b.classList.add('is-active');
      this.selVariant=this.modalData.variants[Number(b.dataset.size)];
      info.querySelector('[data-modal-price]').textContent=this.money(this.selVariant.price);
    }));
    info.querySelectorAll('.pcs-sb__acc-head').forEach(h=> h.addEventListener('click', ()=> h.closest('.pcs-sb__acc-item').classList.toggle('is-open')));
    info.querySelector('[data-modal-add]').addEventListener('click', ()=>{
      const d=this.modalData, v=this.selVariant;
      this.addToBundle({ vid:v.id, pid:d.id, title:d.title, variantTitle:(d.variants.length>1?v.title:''), price:v.price, image:d.image });
      this.closeModal();
    });
  }

  /* ---- Bundel ---- */
  addToBundle(item){
    const ex=this.bundle.find(b=>b.vid===item.vid);
    if(ex) ex.qty++; else this.bundle.push({...item, qty:1});
    this.render();
  }
  changeQty(vid, delta){
    const it=this.bundle.find(b=>b.vid===vid); if(!it) return;
    it.qty+=delta; if(it.qty<=0) this.bundle=this.bundle.filter(b=>b.vid!==vid);
    this.render();
  }
  removeItem(vid){ this.bundle=this.bundle.filter(b=>b.vid!==vid); this.render(); }

  render(){
    const count=this.bundle.reduce((s,b)=>s+b.qty,0);
    const subtotal=this.bundle.reduce((s,b)=>s+b.price*b.qty,0);
    const pct=this.discountFor(count);
    const discount=Math.round(subtotal*pct/100);
    const total=subtotal-discount;

    this.querySelectorAll('[data-count]').forEach(e=>e.textContent=count);
    this.querySelectorAll('[data-disc]').forEach(e=>e.textContent=pct>0?('-'+pct+'%'):'-');
    this.querySelectorAll('[data-bundle-add]').forEach(b=>b.disabled=count===0);

    // stepper
    this.querySelectorAll('[data-step]').forEach(s=> s.classList.toggle('is-reached', count>=Number(s.dataset.step)));
    this.querySelectorAll('[data-line]').forEach(l=> l.classList.toggle('is-reached', count>=Number(l.dataset.line)));
    // tier cards
    const activeTier=count>=5?5:count;
    this.querySelectorAll('[data-tier-card]').forEach(t=> t.classList.toggle('is-active', Number(t.dataset.tierCard)===activeTier && count>=2));
    // tab-count per panel
    this.querySelectorAll('[data-panel]').forEach(panel=>{
      const id=panel.dataset.panel;
      const pids=Array.from(panel.querySelectorAll('[data-card]')).map(c=>Number(c.dataset.pid));
      const chosen=this.bundle.filter(b=>pids.includes(b.pid));
      const n=chosen.reduce((s,b)=>s+b.qty,0);
      const counter=this.querySelector('[data-tab-count="'+id+'"]');
      if(counter) counter.textContent=n>0?n:'';
    });
    // card in-bundle highlight
    this.querySelectorAll('[data-card]').forEach(c=>{
      const inB=this.bundle.some(b=>b.pid===Number(c.dataset.pid));
      c.classList.toggle('is-in-bundle', inB);
    });
    // discount pill
    const pill=this.querySelector('[data-disc-pill]');
    if(count===0) pill.textContent=this.i18n.pillStart||'Voeg 2+ pannen toe en bespaar';
    else if(count===1) pill.textContent=this.i18n.pillOne||'Nog 1 pan voor 5% korting';
    else if(count>=5) pill.textContent=this.i18n.pillMax||'🎉 Maximale korting van 20% toegepast';
    else pill.textContent=pct+'% '+(this.i18n.pillMidApplied||'korting toegepast. Voeg nog 1 toe voor')+' '+this.discountFor(count+1)+'%';

    // sidebar body
    const body=this.querySelector('[data-side-body]');
    if(count===0){ body.innerHTML='<p class="pcs-sb__side-empty">'+(this.i18n.emptySet||'Nog geen pannen gekozen. Kies hiernaast je eerste pan.')+'</p>'; return; }
    let html='<div class="pcs-sb__side-items">';
    this.bundle.forEach(b=>{
      html+='<div class="pcs-sb__side-item"><img src="'+(b.image||'')+'" alt="">'+
        '<div class="pcs-sb__side-item-info"><b>'+b.title+'</b>'+(b.variantTitle?'<span>'+b.variantTitle+'</span>':'')+'</div>'+
        '<div class="pcs-sb__side-qty"><button type="button" data-q-dec="'+b.vid+'">-</button><span>'+b.qty+'</span><button type="button" data-q-inc="'+b.vid+'">+</button></div>'+
        '<span class="pcs-sb__side-price">'+this.money(b.price*b.qty)+'</span>'+
        '<button type="button" class="pcs-sb__side-rm" data-q-rm="'+b.vid+'" title="Verwijderen">&times;</button></div>';
    });
    html+='</div><div class="pcs-sb__side-totals">';
    if(pct>0){
      html+='<div class="pcs-sb__side-row"><span>'+(this.i18n.origPrice||'Originele prijs')+'</span><span>'+this.money(subtotal)+'</span></div>'+
            '<div class="pcs-sb__side-row save"><span>'+(this.i18n.discountLbl||'Korting')+' ('+pct+'%)</span><span>-'+this.money(discount)+'</span></div>'+
            '<div class="pcs-sb__side-grand"><span>'+(this.i18n.yourPrice||'Jouw prijs')+'</span><span>'+this.money(total)+'</span></div>';
    } else {
      html+='<div class="pcs-sb__side-grand"><span>'+(this.i18n.totalLbl||'Totaal')+'</span><span>'+this.money(subtotal)+'</span></div>';
    }
    html+='</div>';
    body.innerHTML=html;
    body.querySelectorAll('[data-q-inc]').forEach(b=>b.addEventListener('click',()=>this.changeQty(Number(b.dataset.qInc),1)));
    body.querySelectorAll('[data-q-dec]').forEach(b=>b.addEventListener('click',()=>this.changeQty(Number(b.dataset.qDec),-1)));
    body.querySelectorAll('[data-q-rm]').forEach(b=>b.addEventListener('click',()=>this.removeItem(Number(b.dataset.qRm))));
  }

  initCarousel(){
    this.querySelectorAll('.pcs-sb__carousel').forEach(car=>{
      const track=car.querySelector('[data-track]');
      if(!track) return;
      const scrollAmt=()=>Math.max(220, track.clientWidth * 0.8);
      car.querySelector('[data-car-prev]')?.addEventListener('click', ()=> track.scrollBy({ left: -scrollAmt(), behavior: 'smooth' }));
      car.querySelector('[data-car-next]')?.addEventListener('click', ()=> track.scrollBy({ left:  scrollAmt(), behavior: 'smooth' }));
    });
  }

  initBundleButtons(){
    this.querySelectorAll('[data-bundle-add]').forEach(btn=> btn.addEventListener('click', ()=> this.addBundleToCart(btn)));
    this.querySelector('[data-mobilebar]'); // ref
    window.addEventListener('scroll', ()=>{
      const bar=this.querySelector('[data-mobilebar]');
      if(this.bundle.length>0) bar.classList.add('is-visible'); else bar.classList.remove('is-visible');
    });
  }
  async addBundleToCart(btn){
    if(this.bundle.length===0) return;
    const orig=btn.textContent; btn.textContent=this.i18n.busy||'Bezig...'; btn.disabled=true;
    try{
      const items=this.bundle.map(b=>({ id:b.vid, quantity:b.qty }));
      const r=await fetch('/cart/add.js',{ method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ items }) });
      if(r.ok){ window.location.href='/cart'; } else { btn.textContent=orig; btn.disabled=false; }
    }catch(e){ console.error('bundle add', e); btn.textContent=orig; btn.disabled=false; }
  }
}
customElements.define('pcs-set-bouwer', PcsSetBouwer);

  } catch(e) { console.error(e); }
})();
})();
